import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Lang_term_bs$SolvuuApi0 from "./lang_term_bs.bs.js";
var write_info = Atdgen_codec_runtime.Encode.make(function (t) {
  return Atdgen_codec_runtime.Encode.obj(
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Lang_term_bs$SolvuuApi0.write_t, "term", t.term),
  /* :: */
  [Atdgen_codec_runtime.Encode.field(undefined, Atdgen_codec_runtime.Encode.make(function (x) {
    if (x >= 826371656) {
      return Atdgen_codec_runtime.Encode.constr0("Json");
    } else {
      return Atdgen_codec_runtime.Encode.constr0("Solvuu");
    }
  }), "response_term_fmt", t.response_term_fmt),
  /* [] */
  0]]);
});
var read_info = Atdgen_codec_runtime.Decode.make(function (json) {
  var partial_arg = Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Solvuu",
  /* `Single */
  [-306849112,
  /* Solvuu */
  -522825178]],
  /* :: */
  [
  /* tuple */
  ["Json",
  /* `Single */
  [-306849112,
  /* Json */
  826371656]],
  /* [] */
  0]]);
  return {
    term: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("term", Lang_term_bs$SolvuuApi0.read_t, param);
    }, json),
    response_term_fmt: Atdgen_codec_runtime.Decode.decode(function (param) {
      return Atdgen_codec_runtime.Decode.field("response_term_fmt", partial_arg, param);
    }, json)
  };
});
var read_term = Lang_term_bs$SolvuuApi0.read_t;
var write_term = Lang_term_bs$SolvuuApi0.write_t;
export { read_term, write_term, read_info, write_info };
/* write_info Not a pure module */